<template>
  <div class="animation-apple">
    <img class="apple-half" id="apple-left" src="../assets/bg-animations/apple/apple-left.png" />
    <img class="apple-half"  id="apple-right" src="../assets/bg-animations/apple/apple-right.png" />
  </div>
</template>

<script>

import {gsap} from 'gsap'

export default {
  name: 'AppleAnimation',
  props: ['start'],
  components:{
  },
  data(){
    return {

    }
  },
  methods:{
    startTransition(){
      
      var TL = gsap.timeline({delay: 0})
      TL
      .to('.apple-half',{opacity: 1, top: '70%', duration: 1})
      .to('#apple-left',{rotate: -25, duration: .5})
      .to('#apple-right',{rotate: 25, duration: .5}, '-=.45')
      .to('.apple-half',{opacity: 0, duration: .5}, '+=0.5')
    }
  },
  mounted(){
    
  },
  computed:{
   
  },
  watch: {
    start(){
      this.startTransition()
    }
  }
}
</script>

<style lang="scss">
  .animation-apple {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    pointer-events: none;
    img{
      position: absolute;
      opacity: 0;
      top: -100%;
      left: 50%;
      width: 300px;
      transform-origin: bottom center;
      &#apple-left{
        transform: translate(-100%, -50%);
      }
      &#apple-right{
        transform: translate(-71px, -50%);
        @media screen and (max-width: 768px) {
          transform: translate(-11px, -50%);
        }
      }
      @media screen and (max-width: 768px) {
        width: 100px;
        height: auto;
      }
    }
  }
</style>